import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { GoogleOAuthProvider } from "@react-oauth/google";
import reportWebVitals from './reportWebVitals';

// Remove Google linker tracking param from the visible URL.
if (window.location.search.includes('_gl=')) {
  const params = new URLSearchParams(window.location.search);
  params.delete('_gl');
  const nextSearch = params.toString();
  const cleanUrl = `${window.location.pathname}${nextSearch ? `?${nextSearch}` : ''}${window.location.hash}`;
  window.history.replaceState({}, document.title, cleanUrl);
}

const root = ReactDOM.createRoot(document.getElementById('root')); 
const GoogleClientID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
root.render(
  <React.StrictMode>                 
        <GoogleOAuthProvider clientId={GoogleClientID}>
       <App /> 
     </GoogleOAuthProvider>
  </React.StrictMode>
);
 
reportWebVitals();
